import { ContractForm } from "..";

  function ContractFormv2() {

    return (
      <>
       <ContractForm contractNumber={2}/>
      </>
    );
  }
  
  export default ContractFormv2;
  